<template>
  <div class="reference-filters-header pa-4 pt-6">
    <div>Filtering <v-icon right>filter_list</v-icon></div>
    <div>
      <v-chip small @click="$emit('clear-all')">
        <v-icon class="mr-1">clear_all</v-icon>
        <span class="font-weight-medium">Clear All</span>
      </v-chip>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReferenceFiltersHeader',
  emits: ['clear-all'],
};
</script>

<style lang="scss" scoped>
@import '~vuetify/src/styles/styles.sass';

$reference-filter-header-text-color: map-get($grey, 'darken-2');

.reference-filters-header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  background-color: white;

  color: $reference-filter-header-text-color;
  .v-chip {
    color: $reference-filter-header-text-color;
  }
}
</style>
